import type { FC } from "react";
import type { Theme } from "@material-ui/core";
import { CardMedia } from "@material-ui/core";
import type { SxProps } from "@material-ui/system";
import ImgLogo from "../images/logos/mainheader.png";

interface LogoProps {
    sx?: SxProps<Theme>;
    width?: string;
}

// const LogoRoot = experimentalStyled('svg')``;

// const logo = "https://thanglong.edu.vn/themes/md_tlu/img/logo.svg";
const logo = "/static/images/logos/neu.png";

const UEHLogo: FC<LogoProps> = (props) => (
    <CardMedia {...props}>
        <title>NEU-Logo</title>
        <img width={props.width} src={logo} />
    </CardMedia>
);

export default UEHLogo;

// import type { FC } from 'react';
// import ImgLogo from "../images/logos/logoNhoUEH.jpg"
// import Logo from './Logo';
// import '../css/Header.scss'
// import { styled } from '@mui/system';

// const LogoUEH = styled(Logo)`div`;
// const UEHLogo = (props) => {
//   console.log(props);
//   return(
//   <img className={props ? '' : ''} height='60' width='60' src = {ImgLogo}/>
// )};

// export default UEHLogo;
